/**
 * 获取文件名后缀
 * @param filePath
 * @returns {string}
 */
export function getFileExt(filePath) {
    let index= filePath.lastIndexOf(".");
//获取后缀
    let ext = filePath.substring(index+1);
    return ext;
}
